import React from "react";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectFormData } from "../../slices/form";

const closedTypeList = [
  "Knowledge: Ability to remember specific information.",
  "Comprehension: Ability to make connections between concepts.",
  "Analysis: Ability to analyze and think critically.",
  "Application: Ability to apply learned concepts.",
];

const openTypeList = [
  "Theme: Ability to identify main idea and supporting details.",
  "Analysis: Ability to analyze and think critically.",
  "Structure: Ability to identify organization of a text.",
  "Tone: Ability to recognize and interpret tone and mood.",
  "Vocabulary: Ability to understand the meaning of words or phrases from context.",
];

const mathTypeList = [
  "Fluency: Ability to accurately and efficiently carry out grade‑appropriate calculations and algorithms.",
  "Concepts: Understanding of underlying mathematical ideas, relationships, and representations.",
  "Applications: Real‑world or word‑problem contexts; selecting and using appropriate strategies.",
  "Reasoning: Justify or explain mathematical thinking, critique flawed arguments, or compare strategies.",
];

const ToolsTooltip = ({ name }) => {
  const formData = useSelector(selectFormData);

  const { show_text } = formData || {};
  const { subject } = formData || {};
  const newType = show_text === "Closed book" ? "close" : "open";

  let currentTypeList;
  if (subject && subject.toLowerCase() === "math") {
    currentTypeList = mathTypeList;
  } else {
    currentTypeList = newType === "close" ? closedTypeList : openTypeList;
  }

  return (
    <Tooltip
      title={
        <React.Fragment>
          <Typography color="inherit">{subject && subject.toLowerCase() === "math" ? "Math" : show_text}</Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <p>We support the following skill assessment categories:</p>
            <ul style={{ paddingLeft: "14px", listStyle: "unset" }}>
              {currentTypeList.map((list, index) => {
                return <li key={`${index}${list}`}>{list}</li>;
              })}
            </ul>
          </Box>
        </React.Fragment>
      }
    >
      <InfoOutlinedIcon style={{ fontSize: 17 }} />
    </Tooltip>
  );
};

export default ToolsTooltip;
